// The real Terum brand mark — the terum.ai favicon SVG (uses currentColor so it
// inherits the surrounding text/accent color). Paths copied verbatim from the
// #terumlogo <symbol> in mockups/onboarding/index.html.

export function TerumLogo({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="2190 1925 200 200"
      aria-hidden="true"
      className={className}
    >
      <path
        fill="currentColor"
        d="M2234.6,2001.57c-14.32,19.89,10.46,28.26,29.27,22.25,34.1-10.89,15.5,20.7-7.13,22.89-36.74,3.55-58.92-37.29-15.41-50.31,6.8-1.1-3.84,2.09-6.73,5.17Z"
      />
      <path
        fill="currentColor"
        d="M2316.73,2022.24c2.49-15.83,23.82-16.49,34.96-11.8,8.34,3.73,12.81,11.87,14.58,19.77,2.85,11.59-4.9,20.18-14.83,23.81-.27.19-.77.24-.85-.21-.06-.67.58-1.11,1-1.61.61-.69,1.2-1.08,1.79-1.81,1.52-1.88,1.49-3.75,1.84-5.73,1.28-12.5-9.24-19.95-18.42-18.07-2.91.56-5.38,2.21-7.84,3.54-5.97,3.14-10.07-.26-12.22-4.85"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth=".07"
        strokeMiterlimit="10"
        d="M2264.84,2003.67c-1.9-19.03,18.11-89.27,39.19-31.07,8.87,34.48,10.56,75.41-1.22,111.23-18.51,46.55-43.66-23.52-33.09-29.46,1.88,7.6,2.42,16.74,9.86,22.29,23.86,12.5,12-79.41,11.54-81.18-8.65-33.28-18.8-16.42-22.67,6.39-.4,2.36-1.15,6.23-3.21,3.01-.27-.51-.53-4.39-.46-9.75"
      />
      <circle
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        cx="2289.98"
        cy="2025.81"
        r="92.07"
      />
    </svg>
  );
}
